import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import cache from 'lscache';

import type { Site } from '../apis/userinfo.type';
import { storeStorageKey } from '../components/auth/constants';

interface IcarePersonalUserInfo {
  displayName: string;
  preferredLanguage: string;
  uid: string;
  jobname?: string;
  sitePartyNumber: string;
}

export interface IcareSiteUserInfo {
  selectedSite: Site;
  regionalWorkshopId: number | null;
  countryId?: number;
  categoryWithBattery: number[];
}

type IcareUserInfo = IcarePersonalUserInfo & IcareSiteUserInfo;

export const initialState: IcareUserInfo = {
  displayName: '',
  preferredLanguage: '',
  regionalWorkshopId: null,
  sitePartyNumber: '',
  selectedSite: {
    address: {
      countryCode: '',
    },
    id: cache.get(storeStorageKey) ?? 0,
    name: '',
    shortName: '',
    currency: '',
    maxExpressAmount: 0,
    allowSad: false,
  },
  uid: '',
  categoryWithBattery: [],
};

const userInfoSlice = createSlice({
  name: 'userinfo',
  initialState,
  extraReducers: builder => builder.addCase('resetStore', () => initialState),
  reducers: {
    addPersonalUserInfo: (state, action: PayloadAction<IcarePersonalUserInfo>) => ({
      ...state,
      displayName: action.payload.displayName,
      preferredLanguage: action.payload.preferredLanguage,
      uid: action.payload.uid,
      jobname: action.payload.jobname,
      sitePartyNumber: action.payload.sitePartyNumber,
    }),
    addUserInfo: (state, action: PayloadAction<IcareSiteUserInfo>) => ({
      ...state,
      ...action.payload,
    }),
  },
});

export const {
  reducer: userInfoReducer,
  actions: { addUserInfo, addPersonalUserInfo },
} = userInfoSlice;
